// extracted by mini-css-extract-plugin
export default {"popup_wrap":"ChangePassword_popup_wrap__B4eB5","content_popup":"ChangePassword_content_popup__1eRFC"};